var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectron(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 104,
    viewBox: "0 0 286 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.0791 70.0857H161.649L187.268 95.7046H225.244",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.614 97.8937C228.899 97.8937 229.94 96.8525 229.94 95.5682C229.94 94.2839 228.899 93.2427 227.614 93.2427C226.33 93.2427 225.289 94.2839 225.289 95.5682C225.289 96.8525 226.33 97.8937 227.614 97.8937Z",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H79.5689L105.188 26.6189H143.164",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.535 28.808C146.82 28.808 147.861 27.7668 147.861 26.4825C147.861 25.1981 146.82 24.157 145.535 24.157C144.251 24.157 143.21 25.1981 143.21 26.4825C143.21 27.7668 144.251 28.808 145.535 28.808Z",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.18 25.3872L154.733 49.8341H137.6",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.422 51.1525C137.196 51.1525 137.823 50.5249 137.823 49.7507C137.823 48.9765 137.196 48.3489 136.422 48.3489C135.647 48.3489 135.02 48.9765 135.02 49.7507C135.02 50.5249 135.647 51.1525 136.422 51.1525Z",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.391 25.7051C181.165 25.7051 181.792 25.0778 181.792 24.304C181.792 23.5302 181.165 22.9028 180.391 22.9028C179.617 22.9028 178.99 23.5302 178.99 24.304C178.99 25.0778 179.617 25.7051 180.391 25.7051Z",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.826 76.6028L131.272 101.05H148.406",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.585 102.368C150.359 102.368 150.986 101.741 150.986 100.967C150.986 100.193 150.359 99.5659 149.585 99.5659C148.811 99.5659 148.184 100.193 148.184 100.967C148.184 101.741 148.811 102.368 149.585 102.368Z",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.615 76.9199C106.389 76.9199 107.017 76.2926 107.017 75.5188C107.017 74.745 106.389 74.1177 105.615 74.1177C104.842 74.1177 104.214 74.745 104.214 75.5188C104.214 76.2926 104.842 76.9199 105.615 76.9199Z",
    stroke: "#222532",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.771 61.3768H187.537L201.644 47.2695H244.726L260.549 63.0918H281.709",
    stroke: "#222532",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M283.185 64.7301C284.095 64.7301 284.832 63.9928 284.832 63.0833C284.832 62.1738 284.095 61.4365 283.185 61.4365C282.276 61.4365 281.539 62.1738 281.539 63.0833C281.539 63.9928 282.276 64.7301 283.185 64.7301Z",
    stroke: "#222532",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectron);
export default __webpack_public_path__ + "static/media/electron.783ebf471f445931c49d6a0e78caf227.svg";
export { ForwardRef as ReactComponent };